import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { getPaymentHistory } from "../../../actions/marketplace-action";
import PayoutHistoryModal from "./PayoutHistoryModal";
import RequestPaymentModal from "./RequestPaymentModal";

const PersonalBalancePanel = (props)=>{
    const {getPaymentHistory,t} = props;
    const [showPayoutModal,setShowPayoutModal] = useState(false)
    const [showRequestPaymentModal,setshowRequestPaymentModal] = useState(false)
    useEffect(()=>{
        getPaymentHistory()
    },[])
    const marketplaceDashboard =  useSelector((state) => state.marketplace.marketplaceDashboard) || {};
    return (
        <div className="personal-bal-div">   
            <Row className="text-title mt-4">
                <Col xs={12}>
                    <h6>{t("pb")}</h6>
                    <h4 className="balance-colour bold">US${marketplaceDashboard.lifetime_earn}</h4>
                   
                </Col>
                
            </Row>
            <Row className="text-title mt-4">
                <Col xs={12}>
                    <p>{t("analytics")}</p>
                    <ul className="personal-bal-analytics-list">
                        <li>{t("total-renters")}: <span>{marketplaceDashboard.total_renter}</span></li>
                        <li>{t("ar")}: <span>{marketplaceDashboard.active_renter}</span></li>
                        <li>{t("life-earn")}: <span>US${marketplaceDashboard.lifetime_earn && marketplaceDashboard.lifetime_earn.toFixed(2)}</span></li>
                    </ul>
                    <Button className="payout-history btn" block={true} variant="success" onClick={() => setshowRequestPaymentModal(true)} disabled={marketplaceDashboard.current_earn<=20}>
                    {t("req-p")}
                    </Button>
                    <Button className="payout-history btn" block={true} variant="secondary" onClick={() => setShowPayoutModal(true)}>
                    {t("pay-his")}
                    </Button>
                </Col>
                <Col xs={12} className="mt-5">
                <table className="table  table-borderless table-responsive">
                    <thead>
                        <tr>
                        <th scope="col"></th>
                        <th scope="col">{t("month")}</th>
                        <th scope="col">{t("quarter")}</th>
                        <th scope="col">{t("year")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <th scope="row"> {t("t-rev")}</th>
                        <td>{marketplaceDashboard.month_earn && marketplaceDashboard.month_earn.toFixed(2)}</td>
                        <td>{marketplaceDashboard.quarter_earn && marketplaceDashboard.quarter_earn.toFixed(2)}</td>
                        <td>{marketplaceDashboard.year_earn && marketplaceDashboard.year_earn.toFixed(2)}</td>
                        </tr>
                        <tr>
                        <th scope="row">{t("total-renters")}</th>
                        <td>{marketplaceDashboard.month_renter}</td>
                        <td>{marketplaceDashboard.quarter_renter}</td>
                        <td>{marketplaceDashboard.year_renter}</td>
                        </tr>
                    </tbody>
                    </table>
                </Col>
                
            </Row>
            {showPayoutModal && <PayoutHistoryModal onHide={()=>setShowPayoutModal(false)} /> }
            {showRequestPaymentModal && <RequestPaymentModal onHide={()=>setshowRequestPaymentModal(false)} defaultAmount={marketplaceDashboard.current_earn && marketplaceDashboard.current_earn.toFixed(2)}
        payOutHistoryPendingData={[]} t={t}/> }
        </div>
       
    );
}
export default connect(null,{getPaymentHistory})(PersonalBalancePanel)
